/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AcquisitionClickParam } from './AcquisitionClickParam';
import {
    AcquisitionClickParamFromJSON,
    AcquisitionClickParamFromJSONTyped,
    AcquisitionClickParamToJSON,
    AcquisitionClickParamToJSONTyped,
} from './AcquisitionClickParam';

/**
 * 
 * @export
 * @interface LoginCodeBody
 */
export interface LoginCodeBody {
    /**
     * 
     * @type {string}
     * @memberof LoginCodeBody
     */
    verificationCode: string;
    /**
     * 
     * @type {string}
     * @memberof LoginCodeBody
     */
    referralCode?: string;
    /**
     * 
     * @type {string}
     * @memberof LoginCodeBody
     */
    utmSource?: string;
    /**
     * utm_medium from the landing URL. Resolves PAID_MEDIA, which utm_source alone cannot.
     * @type {string}
     * @memberof LoginCodeBody
     */
    utmMedium?: string;
    /**
     * utm_campaign from the landing URL. Stored verbatim as the campaign attribution reports against.
     * @type {string}
     * @memberof LoginCodeBody
     */
    utmCampaign?: string;
    /**
     * document.referrer at landing. Separates EARNED from DIRECT for an untagged arrival.
     * @type {string}
     * @memberof LoginCodeBody
     */
    referrer?: string;
    /**
     * Path + query the signup journey started on. Joins per-page traffic to per-page signups.
     * @type {string}
     * @memberof LoginCodeBody
     */
    landingPage?: string;
    /**
     * 
     * @type {AcquisitionClickParam}
     * @memberof LoginCodeBody
     */
    clickParam?: AcquisitionClickParam;
    /**
     * The ad platform's click identifier, exactly as it arrived. Stored with clickParam so an activated player can later be reported back to the platform that produced the click. Ignored unless both halves are present and the parameter is recognised.
     * @type {string}
     * @memberof LoginCodeBody
     */
    clickValue?: string;
    /**
     * Friend invite code from ?friendInvite= URL param. Auto-accepts friendship on new account creation.
     * @type {string}
     * @memberof LoginCodeBody
     */
    friendInviteCode?: string;
    /**
     * Optional challenge slug. When provided, the challenge's emailConfig.welcomeEmailTemplateId is used for the new-user welcome email (highest priority, overrides partnerService and referralCode templates).
     * @type {string}
     * @memberof LoginCodeBody
     */
    challengeSlug?: string;
    /**
     * Optional Drop slug. When provided and the Drop carries an onboarding experience, that experience's emailConfig.welcomeEmailTemplateId brands the welcome email (same priority tier as challengeSlug). Explicit slug only — never inferred.
     * @type {string}
     * @memberof LoginCodeBody
     */
    dropSlug?: string;
}



/**
 * Check if a given object implements the LoginCodeBody interface.
 */
export function instanceOfLoginCodeBody(value: object): value is LoginCodeBody {
    if (!('verificationCode' in value) || value['verificationCode'] === undefined) return false;
    return true;
}

export function LoginCodeBodyFromJSON(json: any): LoginCodeBody {
    return LoginCodeBodyFromJSONTyped(json, false);
}

export function LoginCodeBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): LoginCodeBody {
    if (json == null) {
        return json;
    }
    return {
        
        'verificationCode': json['verificationCode'],
        'referralCode': json['referralCode'] == null ? undefined : json['referralCode'],
        'utmSource': json['utmSource'] == null ? undefined : json['utmSource'],
        'utmMedium': json['utmMedium'] == null ? undefined : json['utmMedium'],
        'utmCampaign': json['utmCampaign'] == null ? undefined : json['utmCampaign'],
        'referrer': json['referrer'] == null ? undefined : json['referrer'],
        'landingPage': json['landingPage'] == null ? undefined : json['landingPage'],
        'clickParam': json['clickParam'] == null ? undefined : AcquisitionClickParamFromJSON(json['clickParam']),
        'clickValue': json['clickValue'] == null ? undefined : json['clickValue'],
        'friendInviteCode': json['friendInviteCode'] == null ? undefined : json['friendInviteCode'],
        'challengeSlug': json['challengeSlug'] == null ? undefined : json['challengeSlug'],
        'dropSlug': json['dropSlug'] == null ? undefined : json['dropSlug'],
    };
}

export function LoginCodeBodyToJSON(json: any): LoginCodeBody {
    return LoginCodeBodyToJSONTyped(json, false);
}

export function LoginCodeBodyToJSONTyped(value?: LoginCodeBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'verificationCode': value['verificationCode'],
        'referralCode': value['referralCode'],
        'utmSource': value['utmSource'],
        'utmMedium': value['utmMedium'],
        'utmCampaign': value['utmCampaign'],
        'referrer': value['referrer'],
        'landingPage': value['landingPage'],
        'clickParam': AcquisitionClickParamToJSON(value['clickParam']),
        'clickValue': value['clickValue'],
        'friendInviteCode': value['friendInviteCode'],
        'challengeSlug': value['challengeSlug'],
        'dropSlug': value['dropSlug'],
    };
}

